import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SocialManagerRoutingModule } from './social-manager-routing.module';
import { SocialManagerSideBarComponent } from './social-manager-side-bar/social-manager-side-bar.component';
import { TranslateModule } from '@ngx-translate/core';


@NgModule({
  declarations: [SocialManagerSideBarComponent],
  imports: [
    CommonModule,
    SocialManagerRoutingModule,
    TranslateModule
  ],
  exports: [
    SocialManagerSideBarComponent
  ]
})
export class SocialManagerModule { }
